import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { getLastResults, getDetailResults } from '@/services/casinoApi';
import "./Result.css";
import ResultModalLayout from '@/components/ResultModalLayout';

// Helper function to get dice image based on value
const getDiceImage = (value) => {
  const diceValue = parseInt(value) || 1;
  return `https://d1arlbwbznybm5.cloudfront.net/v19/static/front/images/sicbo/dice${diceValue}.png`;
};

// Helper function to parse card string (e.g., "2,3,4" or "3,5,6")
const parseDiceValues = (cardString) => {
  if (!cardString) return [];
  return cardString.split(',').map(v => v.trim());
};

const ResultSicbo = ({
  data = [],
  gameData = {},
}) => {
  const [showModal, setShowModal] = useState(false);
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch last results on mount
  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults('sicbo');
        if (response?.data?.data?.res && Array.isArray(response.data.data.res)) {
          setLastResults(response.data.data.res);
        } else if (response?.data?.res && Array.isArray(response.data.res)) {
          setLastResults(response.data.res);
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };

    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleResultClick = useCallback(async (resultItem, index) => {
    setLoading(true);

    const mid = resultItem?.mid;

    // Only fetch if we don't already have this detail result
    if (mid && detailResult?.rid !== mid.toString()) {
      try {
        const response = await getDetailResults('sicbo', mid.toString());
        if (response?.success && response?.data?.data?.t1) {
          setDetailResult(response.data.data.t1);
        }
      } catch (error) {
        console.error('Error fetching detail results:', error);
      }
    }

    setLoading(false);
    setShowModal(true);
  }, [detailResult]);

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  // Get all results for display (combine API results with current game data)
  const allResults = lastResults.length > 0
    ? lastResults.map(r => r.win)
    : data;

  // Format modal data based on selected result - memoized to prevent re-renders
  const modalData = useMemo(() => {
    if (!showModal) return null;

    const resultData = detailResult || (gameData?.data?.data ? {
      rid: gameData.data.data.mid,
      card: gameData.data.data.card,
      win: gameData.data.data.win || gameData.data.data.total,
      rdesc: gameData.data.data.card
    } : null);

    if (!resultData) return null;

    const diceValues = resultData?.card ? parseDiceValues(resultData.card) : [];
    const winValue = resultData?.win || '';

    return {
      roundId: resultData.rid || resultData.mid || 'N/A',
      diceValues,
      winValue,
    };
  }, [showModal, detailResult, gameData]);

  return (
    <>
      <div className="sicbo result-row">
        {allResults.map((result, index) => {
          const resultItem = lastResults[index] || { win: result, mid: null };
          return (
            <div
              key={index}
              className="result-circle-sicbo"
              onClick={() => handleResultClick(resultItem, index)}
              style={{ cursor: 'pointer' }}
            >
              {result}
            </div>
          );
        })}
      </div>

      {showModal && modalData && (
        <ResultModalLayout
          show={showModal}
          onHide={handleCloseModal}
          title="Sic Bo Result"
          loading={loading}
        >
          <div>
            {/* Round ID */}
            <h6 className="text-right round-id" style={{ marginBottom: '1rem' }}>
              <b>Round Id:</b> {modalData.roundId}
            </h6>
            <div className="col-12">
              <div className="text-center luckyseven-img">
                <div className="row">
                  {modalData.diceValues.map((value, idx) => (
                    <div key={idx} className="col-1">
                      <img
                        src={getDiceImage(value)}
                        alt={`Dice ${value}`}
                        style={{ width: '100%', maxWidth: '50px', height: 'auto' }}
                        onError={(e) => {
                          e.target.src = `/assets/img/tabledice/dice${value}.png`;
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
              {/* <div className="text-center mt-3">
                <div>
                  <b className="text-success">Result: </b>
                  {modalData.diceValues.join(',')} | Win: {modalData.winValue}
                </div>
              </div> */}
            </div>
          </div>
        </ResultModalLayout>
      )}
    </>
  );
};

export default ResultSicbo;

